import { Node, Transforms, Editor, Path } from 'slate';
import {
  ReactEditor
} from 'slate-react';
import isUrl from 'is-url';

import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultURLEmbedOptions(url = '') {

  const urlEmbedOptions = {
    url,
    inputValid: url !== '',
    dataLoaded: false,
    dataAvailable: false
  };

  return urlEmbedOptions;

}

export function getDefaultOptions(nodeOptions) {

  const options = {
    ...baseNodeUtilities.getDefaultOptions(),
    urlEmbedOptions: getDefaultURLEmbedOptions(),
    ...nodeOptions,
    width: '40%'
  };

  return options;

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.URL_EMBED
  };

  return node;

}

export function buildNodeV2(url) {

  const node = {
    ...getDefaultOptions(),
    urlEmbedOptions: getDefaultURLEmbedOptions(url),
    type: elementTypes.URL_EMBED
  };

  return node;

}

export function insert(editor, path) {

  Transforms.insertNodes(editor, buildNode(), { at: path });
  Transforms.select(editor, [...path, 0]);
  ReactEditor.focus(editor);

}

export function toggle(editor, options, editorOptions) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions, editorOptions);

}

export function tryConvertToURLEmbed(editor, node, nodePath) {

  const text = Node.string(node).trim();

  if (isUrl(text) === false) {
    return false;
  }

  if (editor.disabledElements.includes(elementTypes.URL_EMBED) === true) {
    return false;
  }

  Editor.withoutNormalizing(editor, () => {
    Transforms.removeNodes(editor, { at: nodePath });
    Transforms.insertNodes(editor, buildNode({ urlEmbedOptions: getDefaultURLEmbedOptions(text) }), { at: nodePath });
    Transforms.insertNodes(editor, HelptapEditor.paragraph.buildNode(), { at: Path.next(nodePath) });
    Transforms.select(editor, Path.next(nodePath));
  });

  return true;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function convertToParagraph(editor, url, text, elementPath) {

  Editor.withoutNormalizing(editor, () => {

    const paragraph = HelptapEditor.paragraph.buildWithLink(url, text);

    Transforms.removeNodes(editor, { at: elementPath });
    Transforms.insertNodes(editor, paragraph, { at: elementPath });

  });

}

export function convertToYouTubeBlock(editor, videoId, elementPath) {

  Editor.withoutNormalizing(editor, () => {

    const youtube = HelptapEditor.youtube.buildNode(videoId);

    Transforms.removeNodes(editor, { at: elementPath });
    Transforms.insertNodes(editor, [youtube], { at: elementPath });

  });

}